import { Button, CircularProgress, useTheme } from "@mui/material";
import { ConnectionType } from "protico-sdk";
import React, { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { Redirect } from "react-router-dom";
import AddFriendModal from "../../components/FriendAction/AddFriendModal";
import MetamaskInstruction from "../../components/MetamaskInstruction";
import { useAppSelector } from "../../hooks";
import { useWeb3Auth } from "../../hooks/useWeb3Auth";
import { ROUTES } from "../../routes";
import { AuthenticateState, KeypairState } from "../../types/types";
import { checkMetamaskInstalled } from "../../utils/metamask";
import FriendList from "./FriendList";
import { ConnectContainer } from "./FriendPage.styles";
import FriendPageLayout from "./FriendPageLayout";
import "./index.css";
const FriendPage = () => {
  const { t } = useTranslation();
  const [modalType, setModalType] = useState<ConnectionType>(
    ConnectionType.CONNECT
  );

  const { keypairState } = useAppSelector((state) => state.keys);
  const { authenticateStatus } = useAppSelector((state) => state.auth);
  const theme = useTheme();
  const [isFriendModalOpen, setIsFriendModalOpen] = useState(false);
  const [isWalletInsOpen, setIsWalletInsOpen] = useState(false);

  const handleWalletInstructionBtnClick = (
    e: React.MouseEvent<HTMLElement>
  ) => {
    setIsWalletInsOpen((prev) => !prev);
  };

  const { logout, isProticoAuthenticated, proticoAuthenticate } = useWeb3Auth();
  const handleReConnect = (e: React.MouseEvent<HTMLElement>) => {
    // after logout, it will be redirect to login page
    logout();
  };

  const handleProticoAuthenticate = () => {
    proticoAuthenticate();
  };

  const handleCloseFriend = () => {
    setIsFriendModalOpen(false);
  };

  const renderButton = (
    textKey: string,
    onClickHandler: any,
    extraChildren?: ReactNode
  ) => {
    return (
      <ConnectContainer
        style={{
          overflowWrap: "break-word",
          width: "80%",
          margin: "auto",
        }}
      >
        {t(textKey)}
        <Button
          className="friendpage-connect-btn"
          variant="outlined"
          onClick={onClickHandler}
        >
          {t("PIN_Signin_Connect_Wallet")}
        </Button>
        {extraChildren}
      </ConnectContainer>
    );
  };

  const getview = () => {
    if (authenticateStatus === AuthenticateState.GUEST) {
      if (checkMetamaskInstalled()) {
        return renderButton("PIN_Signin_Request", handleReConnect);
      } else {
        return renderButton(
          "PIN_Signin_MM_Error",
          handleWalletInstructionBtnClick,
          <MetamaskInstruction
            isOpen={isWalletInsOpen}
            setIsOpen={setIsWalletInsOpen}
          />
        );
      }
    } else if (
      authenticateStatus === AuthenticateState.WALLET &&
      isProticoAuthenticated === false
    ) {
      return renderButton(
        "PIN_Profile_Signin_Request",
        handleProticoAuthenticate
      );
    }
    if (keypairState === KeypairState.WAITING_KEY_AUTH) {
      // never
      return (
        <ConnectContainer>
          <CircularProgress style={{ color: theme.brandColor }} size={25} />
        </ConnectContainer>
      );
    }

    if (keypairState === KeypairState.KEYPAIR_SUCCESS) {
      return (
        <React.Fragment>
          {modalType === ConnectionType.CONNECT && (
            <div
              className="float-button"
              onClick={() => {
                setIsFriendModalOpen(true);
              }}
            >
              <AiOutlineUsergroupAdd size={18} />
            </div>
          )}
          <AddFriendModal
            open={isFriendModalOpen}
            onClose={handleCloseFriend}
            address={""}
          />
          <FriendList modalType={modalType} />
        </React.Fragment>
      );
    }

    return (
      <ConnectContainer>{t("PIN_Signin_Unexpected_Error")}</ConnectContainer>
    );
  };

  const { logined } = useWeb3Auth();
  if (!logined)
    return (
      <Redirect
        to={{
          pathname: ROUTES.LOGIN_PAGE,
        }}
      />
    );

  if (keypairState === KeypairState.WAITING_KEY_AUTH && isProticoAuthenticated)
    return (
      <Redirect
        to={{
          pathname: ROUTES.KEYPAIR_PAGE,
          state: { from: ROUTES.FRIEND_PAGE },
        }}
      />
    );
  return (
    <FriendPageLayout setModalType={setModalType} modalType={modalType}>
      {getview()}
    </FriendPageLayout>
  );
};
export default FriendPage;
